import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import { useAppDispatch } from "hooks/store";
import { useNavigate } from "react-router-dom";
import { toggleDrawer } from "store/slices/main.slice";

const ToolBar = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <div className="z-10 flex h-[68px] items-center justify-between border-b border-red-700/20 bg-primary px-4 shadow-sm md:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <IconButton
          className="max-md:!hidden !text-themeSelColor"
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          <ArrowBackIcon />
        </IconButton>

        <IconButton
          className="md:!hidden !text-themeSelColor"
          onClick={() => dispatch(toggleDrawer())}
          aria-label="Open menu"
        >
          <MenuIcon />
        </IconButton>

        <div className="min-w-0">
          <h1 className="truncate text-lg font-bold text-themeSelColor md:text-xl">
            RANGER ONLINE ADMIN
          </h1>
          <p className="hidden text-xs font-medium text-themeSelColor/80 sm:block">
            Manage orders, settings, inventory, and restaurant timing
          </p>
        </div>
      </div>

      <button
        type="button"
        className="flex h-10 w-10 items-center justify-center rounded-lg bg-white text-gray-900 shadow-sm transition hover:bg-gray-100"
        onClick={() => {
          navigate("/");
          window.location.reload();
        }}
        aria-label="Go to home"
      >
        <HomeIcon className="!text-[22px]" />
      </button>
    </div>
  );
};

export default ToolBar;
